import { render, staticRenderFns } from "./ResultWordEdit.vue?vue&type=template&id=53770cb4&scoped=true"
import script from "./ResultWordEdit.vue?vue&type=script&lang=js"
export * from "./ResultWordEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53770cb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53770cb4')) {
      api.createRecord('53770cb4', component.options)
    } else {
      api.reload('53770cb4', component.options)
    }
    module.hot.accept("./ResultWordEdit.vue?vue&type=template&id=53770cb4&scoped=true", function () {
      api.rerender('53770cb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screeningConfig/physicalConfig/resultWord/ResultWordEdit.vue"
export default component.exports